module.exports = __webpack_public_path__ + "i18n/it.783fbf8166299f5390f327a4eb011794.json";